export enum HardwareDeviceStatus {
  Active = 'Active',
  Inactive = 'Inactive',
}

export enum HardwareDeviceStatusIcon {
  Active = 'check_circle',
  Inactive = 'do_not_disturb_on',
}

export enum HardwareDeviceStatusIconColor {
  Active = 'var(--green-50)',
  Inactive = 'var(--red-50)',
}
